import fastXML, { X2jOptions } from "./libs/fast-xml-parser/src/fxp";
export default class XMLParserSingleton {
  private static _instance: fastXML.XMLParser;

  private constructor() {}

  public static get Instance() {
    if (!XMLParserSingleton._instance) {
      const options: X2jOptions = {
        preserveOrder: true,
        ignoreAttributes: false,
        attributesGroupName: false,
        attributeNamePrefix: "",
        trimValues: false,
        attributeValueProcessor: (name, val, jpath) => {
          return val
            .replaceAll("&#xD;", "\r") // no itx
            .replaceAll("&#xA;", "\n") // no itx
            .replaceAll(/(&.+?;)/g, "<UNHANDLED ENTITY '$1'>"); // no itx
        },
        isArray: (name, jpath, isLeafNode, isAttribute) => {
          return !isAttribute;
        },
      };

      const parser = new fastXML.XMLParser(options);
      // parser.addEntity("#xD", "\r");
      // parser.addEntity("#xA", "\n");
      XMLParserSingleton._instance = parser;
    }

    return XMLParserSingleton._instance;
  }
}
